import { ArrowLeft, Calendar, Users, Plane, Hotel, Utensils, Mountain, Binoculars, Tent, Compass, Leaf, Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TANZANIA_HERO = 'https://images.unsplash.com/photo-1528732533941-ffd7083d5dfe';

const TANZANIA_IMAGES = {
  '1-2': 'https://images.pexels.com/photos/28359728/pexels-photo-28359728.jpeg',
  3: 'https://images.pexels.com/photos/10495959/pexels-photo-10495959.jpeg',
  4: 'https://images.pexels.com/photos/12339600/pexels-photo-12339600.jpeg',
  5: 'https://images.pexels.com/photos/7125439/pexels-photo-7125439.jpeg',
  6: 'https://images.unsplash.com/photo-1745885979468-44a855f8a5fa',
  7: 'https://images.unsplash.com/photo-1580687774725-4e23db308efc',
};

export default function Tanzania() {
  const navigate = useNavigate();

  const days = [
    { day: '1-2', title: 'Tarangire: O Reino dos Elefantes', description: 'Baobás milenares e manadas de elefantes',
      highlights: [
        { icon: Mountain, label: 'Gigantes da Savana', detail: 'Explore o cenário dramático de baobás milenares e savanas douradas' },
        { icon: Binoculars, label: 'Vida Selvagem Abundante', detail: 'Observe búfalos, zebras, gnus, leões e leopardos' },
        { icon: Hotel, label: 'Lake Burunge Baobab Lodge', detail: 'Hospedagem exclusiva com conexão íntima com o ecossistema local' },
        { icon: Compass, label: 'Safaris Guiados', detail: 'Exploração completa do Parque Nacional Tarangire' },
      ],
      highlight: 'Tarangire é o melhor lugar da Tanzânia para observar grandes manadas de elefantes de perto em seu habitat natural.' },
    { day: 3, title: 'Serengeti: A Imensidão Selvagem', description: 'Rumo ao coração da vida selvagem africana',
      highlights: [
        { icon: Leaf, label: 'O Coração da África', detail: 'Deixe as terras altas e entre nas planícies de grama curta do Serengeti' },
        { icon: Mountain, label: 'Palco da Grande Migração', detail: 'Testemunhe o movimento épico de centenas de milhares de gnus e zebras' },
        { icon: Tent, label: 'Kati Kati Tented Camp', detail: 'Acampamento móvel com experiência autêntica de safari' },
        { icon: Compass, label: 'Noite sob as Estrelas', detail: 'Cercado pelos sons da natureza selvagem' },
      ],
      highlight: 'O Serengeti abriga a maior concentração de vida selvagem do planeta, uma experiência verdadeiramente transformadora.' },
    { day: 4, title: 'Serengeti: Exploração Completa', description: 'Aprofunde-se na Grande Migração',
      highlights: [
        { icon: Binoculars, label: 'Exploração Completa', detail: 'Safaris inteiros dedicados ao Serengeti' },
        { icon: Mountain, label: 'Formações Rochosas', detail: 'Explore os kopjes onde predadores vigiam a savana' },
        { icon: Compass, label: 'Vida Selvagem Premium', detail: 'Observação de predadores e presas em seu habitat natural' },
        { icon: Camera, label: 'Fotografia de Safari', detail: 'Oportunidades incríveis para capturar momentos únicos' },
      ],
      highlight: 'Dedique um dia completo ao Serengeti para capturar a essência verdadeira da Grande Migração africana.' },
    { day: 5, title: 'Karatu: Terras Altas & Café', description: 'Transição para as terras altas com experiência cultural',
      highlights: [
        { icon: Mountain, label: 'Terras Altas de Karatu', detail: 'Exploração das regiões elevadas com paisagens espetaculares' },
        { icon: Leaf, label: 'Plantações de Café', detail: 'Visita a fazendas de café tradicionais tanzanianas' },
        { icon: Utensils, label: 'Experiência Gastronômica', detail: 'Refeições com ingredientes locais frescos' },
        { icon: Compass, label: 'Imersão Cultural', detail: 'Encontro com comunidades locais e tradições' },
      ],
      highlight: 'As terras altas de Karatu oferecem um contraste perfeito com os safaris, combinando natureza e cultura.' },
    { day: 6, title: 'Ngorongoro: O Éden Africano', description: 'A cratera vulcânica mais espetacular do mundo',
      highlights: [
        { icon: Mountain, label: 'Cratera de Ngorongoro', detail: 'Exploração da maior cratera vulcânica intacta do mundo' },
        { icon: Binoculars, label: 'Habitat Único', detail: 'Observação de vida selvagem em ambiente de cratera' },
        { icon: Compass, label: 'Paisagens Espetaculares', detail: 'Vistas panorâmicas de tirar o fôlego' },
        { icon: Camera, label: 'Fotografia Premium', detail: 'Oportunidades de capturar a beleza natural' },
      ],
      highlight: 'A Cratera de Ngorongoro é um dos ambientes mais únicos do planeta, um verdadeiro paraíso natural.' },
    { day: 7, title: 'Arusha: Despedida & Retorno', description: 'Encerramento da jornada com memórias inesquecíveis',
      highlights: [
        { icon: Plane, label: 'Retorno para Arusha', detail: 'Transferência para a cidade de Arusha' },
        { icon: Hotel, label: 'Repouso Final', detail: 'Hospedagem confortável antes da partida' },
        { icon: Compass, label: 'Reflexão da Jornada', detail: 'Tempo para processar as experiências vividas' },
        { icon: Camera, label: 'Memórias Inesquecíveis', detail: 'Leve consigo momentos que durarão para sempre' },
      ],
      highlight: 'Encerre sua jornada africana com a certeza de ter vivido uma experiência transformadora e autêntica.' },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="relative h-96 bg-cover bg-center flex items-center justify-center" style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 100%), url('${TANZANIA_HERO}')` }}>
        <div className="text-center text-white z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">ROTEIRO TANZÂNIA</h1>
          <p className="text-xl md:text-2xl font-light">A Essência do Safari Africano</p>
        </div>
      </div>

      <div className="container py-6">
        <button onClick={() => navigate('/#destinations')} className="flex items-center gap-2 text-primary hover:text-accent transition-colors font-semibold">
          <ArrowLeft size={20} /> Voltar aos Destinos
        </button>
      </div>

      <section className="py-12 bg-slate-50">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Uma expedição de 7 dias desenhada para capturar a alma da vida selvagem tanzaniana, do Serengeti à Cratera de Ngorongoro. Explore os parques mais icônicos da África, testemunhe a Grande Migração e viva momentos que transformarão sua perspectiva sobre a natureza.
            </p>
            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="flex flex-col items-center"><Calendar className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">7 Dias</p></div>
              <div className="flex flex-col items-center"><Users className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">A partir de 1 pessoa</p></div>
              <div className="flex flex-col items-center"><Plane className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">Tudo Incluído</p></div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 flex-1">
        <div className="container">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">SEU CRONOGRAMA DE SAFARI</h2>
          <div className="space-y-12">
            {days.map((dayInfo, index) => (
              <div key={dayInfo.day} className="fade-in-up" style={{ animationDelay: `${index * 80}ms` }}>
                <div className="grid md:grid-cols-2 gap-8 items-start">
                  <div>
                    <div className="inline-block px-4 py-2 bg-accent/10 border border-accent/30 rounded-full mb-4">
                      <p className="text-accent font-bold text-sm">DIA {dayInfo.day}</p>
                    </div>
                    <h3 className="text-3xl font-bold text-primary mb-2">{dayInfo.title}</h3>
                    <p className="text-muted-foreground text-lg mb-6">{dayInfo.description}</p>
                    <div className="space-y-4 mb-6">
                      {dayInfo.highlights.map((h, idx) => {
                        const Icon = h.icon;
                        return (
                          <div key={idx} className="flex gap-4">
                            <div className="flex-shrink-0"><Icon className="text-accent" size={24} /></div>
                            <div>
                              <p className="font-semibold text-primary">{h.label}</p>
                              <p className="text-muted-foreground text-sm">{h.detail}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="bg-accent/5 border-l-4 border-accent p-4 rounded">
                      <p className="text-primary font-semibold italic">“{dayInfo.highlight}”</p>
                    </div>
                  </div>
                  <div className="rounded-lg h-96 overflow-hidden shadow-lg">
                    <img src={TANZANIA_IMAGES[dayInfo.day]} alt={dayInfo.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </div>
                </div>
                {index < days.length - 1 && <hr className="my-12 border-slate-200" />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="container">
          <h2 className="text-3xl font-bold text-center mb-12 text-primary">O QUE ESTÁ INCLUÍDO</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
            <div className="flex gap-4"><Hotel className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Hospedagem Premium</h3><p className="text-muted-foreground text-sm">Lodges e acampamentos exclusivos em cada destino</p></div></div>
            <div className="flex gap-4"><Binoculars className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Safaris Guiados</h3><p className="text-muted-foreground text-sm">Guias especializados para cada parque nacional</p></div></div>
            <div className="flex gap-4"><Plane className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Transferências</h3><p className="text-muted-foreground text-sm">Todos os transportes entre destinos inclusos</p></div></div>
            <div className="flex gap-4"><Utensils className="text-accent flex-shrink-0" size={32} /><div><h3 className="font-bold text-primary mb-2">Refeições Gourmet</h3><p className="text-muted-foreground text-sm">Café da manhã, almoço e jantar em todos os dias</p></div></div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary text-white">
        <div className="container text-center">
          <h2 className="text-4xl font-bold mb-4 text-white">Pronto para Viver Esta Experiência?</h2>
          <p className="text-lg mb-8 text-white/90">Entre em contato conosco e customize seu roteiro</p>
          <a href="https://wa.me/5548991904829?text=Olá! Gostaria de orçar o roteiro premium de Tanzânia." target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-white text-primary font-bold rounded-full hover:bg-slate-100 transition-colors">
            Solicitar Orçamento via WhatsApp
          </a>
        </div>
      </section>

      <section className="py-8 bg-slate-50">
        <div className="container text-center text-muted-foreground text-sm">
          <p>PROPOSTA EXCLUSIVA | 2026</p>
          <p>@jmtravel.oficial | CNPJ 64.418.580/0001-14</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
